import { getAuth } from 'firebase/auth';

class AuthService {
  async getAuthToken() {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (!user) {
        throw new Error('No user is signed in');
      }

      const token = await user.getIdToken(true);
      return token;
    } catch (error) {
      console.error('Error getting auth token:', error);
      throw error;
    }
  }
}

const authService = new AuthService();
export default authService; 